import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiAction, generalSet } from '../../store/generalSlice';

const CreateRuleGroup = () => {
  const dispatch = useDispatch();
  const { ruleGroupCreated, loadingRuleGroup } = useSelector((state) => state.general);

  const [name, setName] = useState('');

  if (ruleGroupCreated?._id) {
    dispatch(generalSet({ reduxField: 'ruleGroupCreated', value: {} }));
    window.location.href = `/ruleGroup/${ruleGroupCreated._id}`;
  }
  return (
    <div className='container mt-4' data-aos='fade-up' data-aos-delay='200'>
      <div className='row d-flex justify-content-center'>
        <div className='col-lg-12 d-flex justify-content-center border-bottom' data-aos='fade-up' data-aos-delay='200'>
          <h1>Create a Rule Group</h1>
        </div>
      </div>
      <div className='row d-flex justify-content-center mt-4'>
        <div className='col-md-6 p-3 border'>
          Name
          <input
            type='text'
            className='form-control'
            placeholder='Rule Group name...'
            style={{ textAlign: 'center' }}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
      </div>
      {typeof name === 'string' && name.length > 0 ? (
        <div className='row d-flex justify-content-center mt-4' data-aos='fade-up' data-aos-delay='200'>
          <button
            className='btn btn-outline-primary'
            disabled={loadingRuleGroup}
            onClick={() => {
              dispatch(generalSet({ reduxField: 'loadingRuleGroup', value: true }));
              dispatch(
                apiAction({
                  route: 'ruleGroups/createRuleGroup',
                  reduxField: 'ruleGroupCreated',
                  name,
                  ruleIds: [],
                  setLoading: 'loadingRuleGroup',
                })
              );
            }}
          >
            Create Rule Group
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default CreateRuleGroup;
